import React, { Component } from 'react';
import { ThemeProvider, StyledEngineProvider, createTheme } from '@mui/material/styles';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { inject, observer } from 'mobx-react';
import i18n from 'i18next';
const deepmerge = require('deepmerge');

@inject('menuStore')
@observer
class CustomThemeProvider extends Component {
  render() {
    const { children, menuStore } = this.props;

    // 기본 테마 설정
    const defaultTheme = {
      typography: {
        fontSize: 15,
        fontFamily: [
          i18n.languages[0] === 'ja'
            ? 'Verdana, "Meiryo UI", "メイリオ", Meiryo, "ヒラギノ角ゴ ProN W3", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif'
            : 'Verdana, "Nanum Gothic", Dotum, sans-serif',
        ].join(','),
        subtitle1: { fontWeight: 'bold' },
        button: { textTransform: 'none' },
      },
      palette: {
        primary: {
          main: '#0070CD',
          contrastText: '#fff',
        },
        secondary: {
          main: '#3d3f4c',
          contrastText: '#fff',
        },
        text: {
          main: '#000',
          secondary: '#949494',
        },
        indicator: {
          height: 4,
        },
      },
      components: {
        MuiBadge: {
          styleOverrides: {
            badge: {
              backgroundColor: '#FFD307',
              color: '#000',
            },
          },
        },
      },
    };

    // 테마별 설정
    const themes = {
      GOLDEN_YELLOW: {
        palette: {
          primary: {
            main: '#F0B70F',
          },
          secondary: {
            main: '#422B15',
          },
        },
        components: {
          MuiBadge: {
            styleOverrides: {
              badge: {
                backgroundColor: '#422B15',
                color: '#fff',
              },
            },
          },
        },
      },
    };

    // 기본 설정 값에 테마 설정 값 머지
    const theme = createTheme(deepmerge(defaultTheme, themes[menuStore.storeData?.theme] || {}));

    return (
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <StyledThemeProvider theme={theme}>{children}</StyledThemeProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    );
  }
}

export default CustomThemeProvider;
